import {DataServiceBase} from "../DataServiceBase";

export class ExternalAuthService extends DataServiceBase {
    constructor() {
        super('/api/AuthToken/token');
    }

    getMfeAuth() {
        return this.http.get('/mfe-auth');
    }
}
